import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { INVENTORY_ENDPOINT } from "./constants";
import useFetchWithAuth from "../fetchWithAuth";

export type Inclusion = Partial<{
  id: number;
  inclusions_config_id: number;
  trip_id: number;
  description: string;
  order: number;
  tags: string;
  conditions: string;
  deleted_at: any;
  _ca: number;
  _cb: number;
  _lma: any;
  _lmb: any;
  teaser: string;
  drop_off_time: any;
  drop_off_location: any;
  pick_up_time: any;
  pick_up_location: any;
  title: string;
  icon: string;
  config_description: string;
}>;

type Result = Partial<{
  success: boolean;
  statusCode: number;
  response: Array<Inclusion>;
}>;
type QueryError = {};

const useTripInclusionsQuery = (
  tripId: number,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const url = `${INVENTORY_ENDPOINT}/trips/${tripId}/inclusions`;
  const cacheKey = [url];
  const { fetchWithAuth } = useFetchWithAuth();

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tripId) throw new Error();
      return fetchWithAuth<Result>(url, { params: { include_deleted: true } });
    },
    {
      ...options,
      enabled: !!tripId,
    }
  );
};
export default useTripInclusionsQuery;
